import React from "react";
import { observer } from "mobx-react";

import { ClientNutritionScreen } from "./screens/ClientNutritionScreen";

export const NutritionClientEntry = observer(({ client }) => {
  return <ClientNutritionScreen client={client} />;
});
